var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 3.5H4.5C3.94687 3.5 3.5 3.94687 3.5 4.5V27.5C3.5 28.0531 3.94687 28.5 4.5 28.5H27.5C28.0531 28.5 28.5 28.0531 28.5 27.5V4.5C28.5 3.94687 28.0531 3.5 27.5 3.5ZM10.9156 24.8031H7.20625V12.8719H10.9156V24.8031ZM9.0625 11.2406C8.63727 11.2406 8.22159 11.1145 7.86802 10.8783C7.51446 10.642 7.23889 10.3063 7.07616 9.91339C6.91343 9.52053 6.87085 9.08824 6.95381 8.67118C7.03677 8.25412 7.24154 7.87103 7.54222 7.57035C7.8429 7.26966 8.226 7.06489 8.64306 6.98194C9.06012 6.89898 9.49241 6.94156 9.88527 7.10428C10.2781 7.26701 10.6139 7.54258 10.8502 7.89615C11.0864 8.24971 11.2125 8.66539 11.2125 9.09062C11.2094 10.2781 10.2469 11.2406 9.0625 11.2406ZM24.8031 24.8031H21.0969V19C21.0969 17.6156 21.0719 15.8375 19.1688 15.8375C17.2406 15.8375 16.9438 17.3437 16.9438 18.9V24.8031H13.2406V12.8719H16.7969V14.5031H16.8469C17.3406 13.5656 18.55 12.575 20.3563 12.575C24.1125 12.575 24.8031 15.0469 24.8031 18.2594V24.8031V24.8031Z",
    fill: "#55ACEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinFilled);
export default __webpack_public_path__ + "static/media/LinkedinFilled.5c07cb0f0e3e12ca2bb593c14d37403d.svg";
export { ForwardRef as ReactComponent };